import { Columns, Column } from '@codeparva/ui-components-library';
import React from 'react';
import { HeroTypes } from '../..';
import { Row } from '../../../../../../components/row/Row';
import { FormattedHrs } from '../../../../../sitewide/components/locationMap/components/FormattedHrs';

const onFacilityHrsToggle = () => {};

export const FacilityVariant1 = ({
  curLocation,
  addressDetails,
  renderDetails,
  formattedHrs,
  GenericTextComponent,
}: HeroTypes.TFacilityDetailsVariant) => {
  return (
    <div className="variant1">
      <Row className="is-cp-w-100">
        <Columns className="is-cp-w-100">
          <Column size={5} className="leftCol">
            {renderDetails({
              label: 'Facility Address',
              content: curLocation.addressText,
              clickableTextConfig: addressDetails,
              noPadding: true,
            })}
            {renderDetails({
              label: 'Mailing Address',
              content:
                curLocation?.mailingAddressText || curLocation.addressText,
              noPadding: true,
            })}
          </Column>
          <Column size={7} className="rightCol">
            <Columns className="px-0 py-2 mb-0">
              <Column paddingless>
                <Row className="is-flex-direction-row is-align-items-center">
                  <GenericTextComponent
                    type="phone"
                    text={curLocation.contactNumber}
                    icon="FaPhoneAlt"
                  />
                </Row>
              </Column>
              <Column paddingless>
                <Row className="is-flex-direction-row is-align-items-center">
                  <GenericTextComponent
                    type="email"
                    text={curLocation.emailAddress}
                    icon="FaRegEnvelope"
                  />
                </Row>
              </Column>
            </Columns>
            <Columns>
              <Column>
                {renderDetails({
                  label: 'Facility Office Hours',
                  content: (
                    <FormattedHrs
                      hideToggle
                      formattedHrs={formattedHrs}
                      show="facilityHrsOnly"
                      onFacilityHrsToggle={onFacilityHrsToggle}
                      titleClassName="subtitle1"
                    />
                  ),
                  noPadding: true,
                })}
              </Column>
              <Column>
                {renderDetails({
                  label: 'Storage Access Hours',
                  content: (
                    <FormattedHrs
                      hideToggle
                      formattedHrs={formattedHrs}
                      show="gateHrsOnly"
                      onFacilityHrsToggle={onFacilityHrsToggle}
                      // hideTitles
                      titleClassName="subtitle1"
                    />
                  ),
                  noPadding: true,
                })}
              </Column>
            </Columns>
          </Column>
        </Columns>
      </Row>
    </div>
  );
};
